import { LitElement, html } from 'lit';
import { ApplicationService } from '../../services/application.service.js';
import { DebugService } from '../../shared/services/debug.service.js';

/* Base component for Iconic V2 components, which share functionality
 */
export class IconicV2BaseComponent extends LitElement {
  constructor() {
    super();
    this.validity = {};
    this.displayError = false;
    this.debug = new DebugService(this.tagName);
    this.inputChildren = {};

    this.boundEventHandler = this.eventHandler.bind(this);
  }

  updated(changedProperties) {
    if (
      changedProperties.has('displayError') &&
      changedProperties.get('displayError') === false &&
      this.displayError === true
    ) {
      this.showEditError();
    }
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('mfe-update-application', this.boundEventHandler);
    this.dispatchConnectedEvent();

    if (this.mockApplication) {
      this.debug.log('Setting iconic v2 :)');
      ApplicationService.setMockApplication();
      ApplicationService.isIconicV2 = true;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener(
      'mfe-update-application',
      this.boundEventHandler
    );
  }

  dispatchConnectedEvent() {
    this.debug.log(`Component connected: ${this.tagName.toLowerCase()}`);
    this.dispatchEvent(
      new CustomEvent('host-app-confirmation-page-event', {
        bubbles: true,
        composed: true,
        detail: {
          actionName: 'connected',
          data: { component: this.tagName.toLowerCase() },
        },
      })
    );
  }

  resetValues() {}

  async eventHandler(event) {
    const { actionName } = event.detail;
    this.debug.log('Event caught', actionName);
    switch (actionName) {
      case 'confirmation-page-update-application': {
        const app = event?.detail?.data?.application;
        if (app) {
          ApplicationService.setApplication(app);
        }
        this.debug.log('Update', this.inputChildren);
        this.resetValues();
        this.requestUpdate();
        break;
      }
      default:
    }
    this.debug.log('Application', this.application);
  }

  showEditError() {
    this.debug.log('Display editing error');
    this.displayError = true;
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  render() {
    return html``;
  }
}

customElements.define('refi-iconic-v2-base-component', IconicV2BaseComponent);
